var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcIconMissionH7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "lh110puv0a",
    d: "M0 0h37.735v36.887H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 29.607c0 16.352-13.88 29.607-31 29.607-17.12 0-31-13.255-31-29.607C2 13.255 15.88 0 33 0c17.12 0 31 13.255 31 29.607",
    fill: "#F4E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 65c-8.748 0-16.943-3.298-23.074-9.287a1.342 1.342 0 0 1-.034-1.88 1.3 1.3 0 0 1 1.854-.034c5.64 5.51 13.188 8.544 21.254 8.544 8.046 0 15.579-3.02 21.214-8.504a1.3 1.3 0 0 1 1.854.038c.502.53.485 1.372-.039 1.88C49.905 61.718 41.725 65 33 65",
    fill: "#C63DE8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 18.584)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gs3vvzp6yb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lh110puv0a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.074 0H2.229a28.353 28.353 0 0 0-2.23 11.023c0 11.12 6.422 20.802 15.914 25.864a4.728 4.728 0 0 0 1.942-3.824c0-2.609-2.086-4.724-4.66-4.724h2.066c2.574 0 4.66-2.113 4.66-4.722 0-2.61-2.086-4.724-4.66-4.724h-1.192c2.574 0 4.66-2.115 4.66-4.723 0-2.609-2.086-4.724-4.66-4.724h19.005c2.574 0 4.66-2.114 4.66-4.722 0-2.61-2.086-4.724-4.66-4.724",
    fill: "#E5A4F4",
    mask: "url(#gs3vvzp6yb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.849 43.354c0 6.439-5.15 11.658-11.502 11.658-6.353 0-11.504-5.22-11.504-11.658 0-7.263 11.504-18.535 11.504-18.535S46.849 36.09 46.849 43.354",
    fill: "#C63DE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.576 40.837c-.061-1.713-2.607-4.878-4.197-6.47l1.675-1.72c.49.49 4.792 4.88 4.904 8.105l-2.382.085z",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIconMissionH7);
export default __webpack_public_path__ + "static/media/ic-icon-mission-h-7.25015b9ad681205fbf5d4c62c445783a.svg";
export { ForwardRef as ReactComponent };